import "./burger-menu.css";
import {BurgerDots} from "../../assets/icons/BurgerDots";
import {ReactNode, useEffect, useRef, useState} from "react";

export interface BurgerMenuItem {
    id: number | string;
    label: string;
    icon?: ReactNode | ReactNode[];
    onClick: () => void;
    isDestructive?: boolean;
    withSeparatorAbove?: boolean;
    withSeparatorBelow?: boolean;
}

interface BurgerMenu {
    menuId: string;
    items: BurgerMenuItem[];
}

const BurgerMenu = ({ items, menuId }: BurgerMenu) => {
    const [isOpen, setIsOpen] = useState(false);
    const burgerContainerRef = useRef<HTMLDivElement | null>(null);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (burgerContainerRef.current && !burgerContainerRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div ref={burgerContainerRef} className={`burger-menu-container ${isOpen ? 'open' : ''}`}>
            <div className="burger-menu-trigger" onClick={toggleMenu}>
                <BurgerDots width={24} />
            </div>
            <div className="burger-menu">
                {items.map(item => <div key={`burger-menu-${menuId}-item-${item.id}`} className={`burger-menu-item ${item.isDestructive ? 'destructive' : ''} ${item.withSeparatorAbove ? 'with-separator-above' : ''} ${item.withSeparatorBelow ? 'with-separator-below' : ''}`} onClick={() => {
                    item.onClick();
                    toggleMenu();
                }}>
                    <div className="burger-menu-inner">
                        <div className="burger-menu-item-icon">{item.icon}</div>
                        <div className="burger-menu-item-label">{item.label}</div>
                    </div>
                </div>)}
            </div>
        </div>
    )
}

export default BurgerMenu;
